/* eslint-disable */

// TODO: Define conditions under which a report should be declared as critical and/or expedited

import { CONDITION_CRITICAL, CONDITION_EXPEDITE } from './constants';

export default function (merged, pending, event) {
  return { conditionCritical: null, conditionExpedite: null };
}
